import * as React from 'react';
import { User as GraphQLUser } from '@/gql/__generated__/graphql';

export type User = {
  id: string;
  name: string | null;
  lastName: string | null;
  email: string;
  role: string | null;
  phone: string | null;
  verified: boolean | null;
  passwordSet: boolean;
  profileUpdated: boolean | null;
  documentNumber: string | null;
  termsAccepted: boolean;
};

export interface UserData {
  user: User | null;
  loading: boolean;
  refresh: () => Promise<unknown>;
  logout: () => Promise<unknown>;
}

export const UserContext = React.createContext<UserData>({
  loading: true,
  user: null,
  async refresh() {},
  async logout() {},
});

export const useUser = () => {
  return React.useContext(UserContext);
};

export interface PartialAuthenticationResult {
  user: Pick<GraphQLUser, 'emailVerified' | 'profileUpdated' | 'email'>;
}

export const handleAuthenticationResult = (result: PartialAuthenticationResult) => {
  if (!result.user.emailVerified) {
    console.log('[LOGIN] Account not validated');
    return `?email=${result.user.email ? encodeURIComponent(result.user.email) : ''}`;
  }

  if (result.user.profileUpdated) {
    console.log('[LOGIN] Account validated and profile updated');
    return '/home';
  }

  console.log('[LOGIN] Pending for updated');
  return '/datos-personales/';
};
